import type { TableHeadersType } from "../tableHeadersType";

export const BOM_SAVED_TEMPLATE_HEADER: TableHeadersType[] = [
  {
    label: "template id",
    value: "template_id",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "template name",
    value: "template_name",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "primary item name",
    value: "primary_item_name",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "Branch name",
    value: "branch_name",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "MODIFIED BY",
    value: "created_by",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "Action",
    value: "Action",
    defaultChecked: true,
    checked: true,
  },
];
